import { render, staticRenderFns } from "./AvailableServices.vue?vue&type=template&id=52250652&scoped=true"
import script from "./AvailableServices.vue?vue&type=script&lang=js"
export * from "./AvailableServices.vue?vue&type=script&lang=js"
import style0 from "./AvailableServices.vue?vue&type=style&index=0&id=52250652&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52250652",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VImg,VSpacer})
